var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtonIconOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#11365F"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.894 1.501h.49c1.789.004 3.42.03 3.775.27l.04.035 11.144 10.059c.216.225.184.61.11.976-.107.528-.369 1.082-.666 1.435l-.113.122-6.963 7.72c-.262.255-.6.382-.94.382-.295 0-.59-.096-.832-.29l-.117-.104L2.696 12.63c-.485-.453-1.09-1.304-1.131-1.97-.13-2.078-.037-6.056.026-8.165.008-.256.122-.49.296-.664.173-.172.408-.284.666-.29.722-.017 1.66-.034 2.655-.04l.376-.001h1.31zm-.31 2.904c-.526 0-1.05.2-1.451.598-.402.402-.602.926-.602 1.45 0 .524.2 1.047.601 1.447.402.4.927.6 1.452.6.525 0 1.05-.2 1.45-.6.402-.4.602-.924.602-1.448 0-.523-.2-1.047-.6-1.448-.404-.4-.928-.6-1.453-.6z",
    transform: "translate(-653 -500) translate(393 247.5) translate(260.496 253)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtonIconOffer);
export default __webpack_public_path__ + "static/media/proton-icon-offer.ff791fb48726d1c43936db2ebeb8e791.svg";
export { ForwardRef as ReactComponent };